/**
 * Dynamically loads the Razorpay Checkout SDK script.
 * Returns a promise resolving to true if loaded successfully, or false otherwise.
 */
export const loadRazorpay = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => {
      resolve(true);
    };

    script.onerror = () => {
      resolve(false);
    };

    document.body.appendChild(script);
  });
};

/**
 * Removes any Razorpay iframe containers or left-behind DOM elements
 * to stop background activities (like continuous font fetching).
 */
export const cleanupRazorpay = () => {
  const containers = document.querySelectorAll(".razorpay-container");
  containers.forEach((container) => {
    container.remove();
  });
};

